import React from 'react';
import { connect } from 'react-redux';
import { applicantsActions } from '../_actions';
import '../assets/styles/applicants.css';
import ReactModal from 'react-modal';
import { formatDate } from '_helpers/helpers';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ApplicantDetailsSection from './Partials/ApplicantDetailsSection';

ReactModal.setAppElement('#app');

class ApplicationHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hideHistoryNavbar: window.innerWidth <= 719,
      hash: this.props.hash,
    };

    this.goBack = this.goBack.bind(this);
    this.status = this.status.bind(this);
    this.toggleHistoryNavbar = this.toggleHistoryNavbar.bind(this);
    this.handleHistory = this.handleHistory.bind(this);
  }

  componentDidMount() {
    const { hash } = this.state;

    this.props.dispatch(applicantsActions.viewDetails(hash));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.hash !== this.props.hash) {
      this.setState({ hash: this.props.hash });

      this.props.dispatch(applicantsActions.viewDetails(this.props.hash));
    }
  }

  goBack() {
    window.location.reload();
  }

  handleHistory(hash) {
    this.setState({ hash });
    // Fetch full details of selected history item
    this.props.dispatch(applicantsActions.viewDetails(hash));
  }

  status(code) {
    const statusMap = {
      0: 'Denied',
      1: 'Received',
      2: 'Completed',
      3: 'In review',
      4: 'Offered Position',
      10: 'Denied',
      '-1': 'Incomplete',
    };
    return statusMap[code] || '';
  }

  toggleHistoryNavbar(e) {
    e.preventDefault();
    this.setState((prevState) => ({
      hideHistoryNavbar: !prevState.hideHistoryNavbar,
    }));
  }

  getApplicationHistory() {
    return this.props.applicants?.list?.data?.application_history || [];
  }

  getSelectedApplication() {
    return this.props.applicants?.list || null;
  }

  render() {
    const { hash, hideHistoryNavbar } = this.state;
    const applicationHistory = this.getApplicationHistory();
    const selectedApplication = this.getSelectedApplication();

    return (
      <div className='dashboard_container'>
        <div className='white'>
          <div className='back_to_board dashboard_expiration_date_nav'>
            <div className='back_button'>
              <Link to='#' onClick={this.goBack.bind(this)}>
                <img
                  src={require('../assets/images/back.svg').default}
                  alt='Back'
                  style={{ cursor: 'pointer' }}
                />
              </Link>

              <span>
                <Link to='#' onClick={this.goBack.bind(this)}>
                  Back to Applicant
                </Link>
              </span>
            </div>
            <a className='hide_nav_link btn' onClick={this.toggleHistoryNavbar}>
              {hideHistoryNavbar ? 'Display' : 'Hide'} History Navbar
            </a>
          </div>

          <section className='user-docs res_pdf_container'>
            <div className='onboarding-docs sidebar-form'>
              <section className='d-flex w-100'>
                <div className='doc_info'>
                  {/* Left Panel - History List */}
                  <div
                    className='doc_info-lh doc-list-lh'
                    style={{ display: hideHistoryNavbar ? 'none' : '' }}
                  >
                    <div className='doc-title'>
                      <h3>History</h3>
                    </div>
                    <div className='doc-statusbar doc-listing'>
                      <ul className='doc-lists'>
                        {applicationHistory.map((item) => (
                          <li
                            key={item.id}
                            className={`${item.hash === hash ? 'doc-active' : ''} hist_list`}
                            style={{ cursor: 'pointer' }}
                            onClick={() => this.handleHistory(item.hash)}
                          >
                            <p>
                              <b className='active_green_text'>
                                Submitted : {formatDate(item.date)}
                              </b>
                            </p>
                            <p>{this.status(item.status)}</p>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  {/* Right Panel - Selected Application Details */}
                  <div
                    style={{ width: hideHistoryNavbar ? '100%' : '' }}
                    className='doc_info-rh fs-manifest-wrapper'
                  >
                    <div className='doc-wrapper doc-wrapper-rs'>
                      {selectedApplication ? (
                        <ApplicantDetailsSection
                          applicants={selectedApplication}
                        />
                      ) : (
                        <p style={{ padding: '20px' }}>Loading...</p>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

ApplicationHistory.propTypes = {
  hash: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  applicants: PropTypes.object,
};

function mapStateToProps(state) {
  const { applicants } = state;
  return { applicants };
}

const connectedApplicationHistory =
  connect(mapStateToProps)(ApplicationHistory);
export { connectedApplicationHistory as ApplicationHistory };
